/* lp-allergy.js — generated from the <script> block of the approved local
   preview: working/landing-pages/kelpie-allergy-lander/preview/index.html
   Edit the preview, never this file. */

/* ---- Countdown -----------------------------------------------------------
   ONE deadline value, read by BOTH strips (§2 and §15). Deterministic — it is
   the end of the visitor's local day, NOT a per-session timer that restarts on
   every page load. [CAMPAIGN END DATE REQUIRED — Gabriel input]: this constant
   must be replaced by a single server-set campaign end date-time shared by
   every visitor. The expired copy below is already defined.                 */
(function () {
  var EXPIRED_LABEL = 'This introductory offer has now closed.';
  function deadline() { var d = new Date(); d.setHours(23, 59, 59, 0); return d.getTime(); }
  var END = deadline();
  var a = document.getElementById('cd1'), b = document.getElementById('cd2'),
      lab = document.getElementById('cdLabel');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var ms = END - Date.now();
    if (ms <= 0) {                       // expired state — defined, not blank
      lab.textContent = EXPIRED_LABEL;
      a.textContent = ''; b.textContent = '00:00';
      return;
    }
    var s = Math.floor(ms / 1000), h = Math.floor(s / 3600),
        m = Math.floor((s % 3600) / 60), sec = s % 60;
    var out = h >= 1 ? pad(h) + ':' + pad(m) : pad(m) + ':' + pad(sec);
    a.textContent = out; b.textContent = out;
  }
  tick(); setInterval(tick, 1000);
})();

/* ---- Product gallery (§14) ---------------------------------------------- */
(function () {
  var root = document.getElementById('gal');
  if (!root) return;
  var slides = root.querySelectorAll('.np-gal__stage img');
  var thumbs = root.querySelectorAll('.np-gal__thumbs button');
  var cap = document.getElementById('galCap');
  var caps = ['The bottle — 2 FL OZ / 60 mL', 'The real thing, in a real hand',
              "What's in every 1 mL", 'How much for her weight'];
  var i = 0;
  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    cap.textContent = caps[i];
  }
  root.querySelector('.np-gal__btn--prev').addEventListener('click', function () { show(i - 1); });
  root.querySelector('.np-gal__btn--next').addEventListener('click', function () { show(i + 1); });
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
})();
